export const formateDate = (firestoreTimestamp) => {
  const jsDate = new Date(
    firestoreTimestamp.seconds * 1000 + firestoreTimestamp.nanoseconds / 1000000
  );
  const formattedDate = jsDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate.split("/").join("-");
};

export const isValidUrl = (url) => {
  const urlRegex = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/;
  return urlRegex.test(url);
};

///Index Tabel Data

export const tableData = [
  {
    action: "Brand Ambassador duties and Talent Contest",
    method: "Register your profile and show your talent",
    reason: "You make money & learn skills",
  },
  {
    action: "Speak to Fans for free",
    method: "Skype call",
    reason: "Fans verify it's you",
  },
  {
    action: "Chat to Fans for pay",
    method: "Fan pays by minute",
    reason: "Help Fan as Brand Ambas'dr",
  },
  {
    action: "Teach Fans System",
    method: "You first learn system",
    reason: "Then you teach Fan",
  },
  {
    action: "Card, Scroll Sign & posters",
    method: "More Fans contact you",
    reason: "You earn & build fan base",
  },
  {
    action: "You Record Videos + Make Memorabilia",
    method: "Visit Mementos, Seasonals, Talking Badges",
    reason: "You earn and build fan base",
  },
];

export const getNext5Years = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 5; i++) {
    years.push(`${currentYear + i}-${String(currentYear + i + 1).slice(-2)}`);
  }
  return years;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// profileStyle

export const profileStyles = {
  container: {
    display: "flex",
    alignItems: "center",
  },
  switch: {
    position: "relative",
    width: "50px",
    height: "24px",
    borderRadius: "24px",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
  slider: {
    position: "absolute",
    top: "2px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    transition: "left 0.2s",
  },
  label: {
    marginLeft: "10px",
    fontSize: "16px",
  },
};
